import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import { Subscription } from 'rxjs';
import {select, Store} from '@ngrx/store';
import {loadEditionsMetaData} from 'search/full-card/actions/editions.metadata.actions';
import {selectMetaDataLoading} from 'search/full-card/reducers/editions.metadata.reducer';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-editions-sidebar',
  templateUrl: './editions-sidebar.component.html',
  styleUrls: ['./editions-sidebar.component.scss']
})
export class EditionsSidebarComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();
  public isLoading = false;
  @Input() public editionId: string;

  constructor(
    public store: Store,
    private readonly modal: NgbActiveModal,
    public cdRef: ChangeDetectorRef,
  ) {
  }

  public ngOnInit() {
    if (this.editionId) {
      this.store.dispatch(loadEditionsMetaData({id: this.editionId}));
    }

    this.subscriptions.add(
      this.store.pipe(select(selectMetaDataLoading)).subscribe((loading) => {
        this.isLoading = loading;
      }),
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public onDismissActiveModal() {
    this.modal.dismiss();
  }

}
